import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import { useSetState } from "Helpers/Hooks";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import { CONSTRUCTION_RESULT } from "Stores/actionTypes";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";

const OptimizeGalvanize = () => {
  const { constructionResult } = useSelector((state) => ({
    constructionResult: state.construction.constructionResult,
  }));
  const dispatch = useDispatch();
  const [controls, setControls] = useSetState({
    branchLength: {
      type: "millimeter",
      value: 6000,
      validation: {
        required: true,
        isNumeric: true,
        min: 6000,
        max: 12000,
      },
    },
    action: {
      type: "radio",
      value: { value: 9, key: "graphically" },
      items: [
        { value: 9, key: "graphically" },
        { value: 23, key: "linearly" },
        { value: 27, key: "stickerly" },
        { value: 29, key: "excely" },
      ],
    },
    checkbox: {
      type: "checkbox",
      items: [
        { value: false, key: "isFrame" },
        { value: false, key: "isSash" },
        { value: false, key: "isSashDoor" },
        { value: false, key: "isMulion" },
      ],
    },
  });

  const onChangeRadio = (name, key, value) => {
    setControls({ [name]: { value: value } });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        Extra_OptimizeGalvanize: value,
        action: value.value,
      },
    });
  };

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({ [name]: { items: items } });
    const key = items[index].key;
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        [key]: e.currentTarget.checked,
      },
    });
  };

  const onChangeCheckbox_SelectAll = (e, name) => {
    let selected = {};
    setControls({
      [name]: {
        items: controls[name].items.map((inner) => {
          inner.value = true;
          selected[inner.key] = true;
          return inner;
        }),
      },
    });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        ...selected,
      },
    });
  };

  const onClear = () => {
    setControls({
      action: {
        value: constructionResult.Extra_OptimizeGalvanize,
      },
    });
    setControls({
      branchLength: {
        value: constructionResult.lenBranch,
      },
    });
    setControls({
      checkbox: {
        items: [
          { value: constructionResult.isFrame, key: "isFrame" },
          { value: constructionResult.isSash, key: "isSash" },
          { value: constructionResult.isSashDoor, key: "isSashDoor" },
          { value: constructionResult.isMulion, key: "isMulion" },
        ],
      },
    });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        action: constructionResult.Extra_OptimizeGalvanize.value,
        lenBranch: +constructionResult.lenBranch,
        pageIndex: 190,
      },
    });
  };

  const setValue = (name, value) => {
    setControls({ [name]: { value: value } });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        lenBranch: +value,
      },
    });
  };

  useEffect(() => {
    onClear();
  }, []);

  return (
    <>
      <Grid container className="pt-2">
        <Grid container spacing={2} className="mb-2">
          <Grid item lg={2} sm={4} xs={12}>
            <Input
              setValue={setValue.bind(this)}
              name="branchLength"
              value={controls.branchLength.value}
              validation={controls.branchLength.validation}
              label={<Translator id={"barLength"} />}
              type="text"
              endIcon={<Translator id="millimeter" />}
            />
          </Grid>
          <Grid item lg={10} sm={8} xs={12}>
            <MuiRadioGroup
              name="action"
              value={controls.action.value}
              items={controls.action.items}
              onChange={onChangeRadio}
              translate={true}
              className="horizontalRadio"
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <MuiCheckBoxGroup
            label={<Translator id={"selectProfile"} />}
            name="checkbox"
            value={controls.checkbox.value}
            items={controls.checkbox.items}
            onChange={onChangeCheckbox}
            translate={true}
            selectAllShow
            onSelectAll={onChangeCheckbox_SelectAll}
            className="horizontalCheckbox"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default OptimizeGalvanize;
